import { GET, POST } from '../config'

import {
  IEmployeeDataResponse,
  IEmployeeExitInterviewPayload,
  IEmployeeExitInterviewResponse,
  IEmployeeGenerateOTPPayload,
  IEmployeeGenerateOTPResponse,
  IEmployeeRegistrationPayload,
  IEmployeeSearchCodePayload,
  IEmployeeSearchCodeResponse,
  IEmployeeValidateOTPPayload,
  IEmployeeValidateOTPResponse,
} from '../../../interfaces/employee.interface'

export interface IEmployeeAPI {
  create: (payload: IEmployeeRegistrationPayload) => Promise<IEmployeeDataResponse>
  bypass: (payload: IEmployeeRegistrationPayload) => Promise<IEmployeeDataResponse>
  employment: (payload: IEmployeeSearchCodePayload) => Promise<IEmployeeSearchCodeResponse>
  fetch: (payload: string) => Promise<IEmployeeDataResponse>
  generateOTP: (payload: IEmployeeGenerateOTPPayload) => Promise<IEmployeeGenerateOTPResponse>
  register: (payload: IEmployeeExitInterviewPayload) => Promise<IEmployeeExitInterviewResponse>
  validateOTP: (payload: IEmployeeValidateOTPPayload) => Promise<IEmployeeValidateOTPResponse>
}

export default {
  bypass: (payload: IEmployeeRegistrationPayload): Promise<IEmployeeDataResponse> => {
    return POST('/api/v1/application/bypass/', payload).then((res) => res.data)
  },

  create: (payload: IEmployeeRegistrationPayload): Promise<IEmployeeDataResponse> => {
    return POST('/api/v1/application/', payload).then((res) => res.data)
  },

  employment: (payload: IEmployeeSearchCodePayload): Promise<IEmployeeSearchCodeResponse> => {
    return POST('/api/v1/employment/', payload).then((res) => res.data)
  },

  fetch: (payload: string, params?: any): Promise<IEmployeeDataResponse> => {
    return GET(`/api/v1/application/${payload}/`, params).then((res) => res.data)
  },

  generateOTP: (payload: IEmployeeGenerateOTPPayload): Promise<IEmployeeGenerateOTPResponse> => {
    const { slug } = payload

    return POST(`/api/v1/application/${slug}/create/`, null).then((res) => res.data)
  },

  register: (payload: IEmployeeExitInterviewPayload): Promise<IEmployeeExitInterviewResponse> => {
    const { slug, attributes } = payload

    return POST(`/api/v1/application/${slug}/update/`, { attributes }).then((res) => res.data)
  },

  validateOTP: (payload: IEmployeeValidateOTPPayload): Promise<IEmployeeValidateOTPResponse> => {
    return POST('/api/v1/application/validate/', payload).then((res) => res.data)
  },
}
